import {
  NavItemType,
  NavMenuItemType,
  NavbarItemType,
} from "@/components/organisms/Navbar";
import {
  BOOK_A_DEMO_en,
  GET_STARTED_en,
  START_FOR_FREE_en,
  START_NOW_en,
} from "./common.data";
import { featurePagesData_en } from "./features.data";
import { productPagesData_en } from "./products.data";
import { ROUTE_PATHS } from "./routes";

export const navbarItems_en: NavbarItemType[] = [
  {
    name: "Products",
    type: NavItemType.Menu,
    menuType: NavMenuItemType.Products,
    menuItems: productPagesData_en.map((productData) => ({
      name: productData.otherOfferingsMeta.name,
      link: productData.otherOfferingsMeta.path,
      isNew: productData.otherOfferingsMeta.isNew || false,
    })),
  },
  {
    name: "Features",
    type: NavItemType.Menu,
    menuType: NavMenuItemType.Features,
    menuItems: featurePagesData_en.map((featureData) => ({
      name: featureData.otherOfferingsMeta.name,
      link: featureData.otherOfferingsMeta.path,
    })),
  },
  {
    name: "Stories",
    link: ROUTE_PATHS.CREATOR_STORIES,
    type: NavItemType.Link,
  },
  {
    name: "Pricing",
    link: ROUTE_PATHS.PRICING,
    type: NavItemType.Link,
  },
];

export const signupCopies_en = {
  signupHeading: "Create your free account on Graphy",
  appsumoSignupHeading: "Create your account on Graphy",
  signupDescription: "Start free in 2 minutes, no credit card, no tech skills needed",
  signupDescriptionv2: "No credit card required",
  dontHaveAccount: "Don't have an account?",
  loginHeading: "Welcome back",
  alreadyMember: "Already a member?",
  SignupHeadingAiv2: "Start Free Trial",
  SignupHeadingAi: "Your Knowledge Business, On Autopilot!",
  alreadyHaveAccount:"Already have an account?",
  name: {
    placeholder: "Enter Your Name",
    error: "Please enter your name",
  },
  phoneNumber: {
    placeholder: "Enter Phone Number",
    error: "Please enter your phone number",
  },
  email: {
    placeholder: "Enter Your Email",
    error: "Please enter a valid email address",
  },
  input: {
    error: "Required input",
  },
  OR: "or",
  OTP_SENT: "OTP sent",
  ctas: {
    SIGN_IN: "Sign in",
    SIGN_UP: "Sign up",
    SEND_OTP: "Send OTP",
    RESEND: "Resend",
    RESEND_IN: "Resend in",
    CONTINUE_WITH_GOOGLE: "Continue with Google",
    START_FOR_FREE: START_FOR_FREE_en,
    START_NOW: START_NOW_en,
    BOOK_A_DEMO: BOOK_A_DEMO_en,
    GET_STARTED: GET_STARTED_en,
    CONTINUE: "Continue",
    GET_STARTED_FOR_FREE: "Get Started for Free",
    LOGIN: "Log in",
  },
};

export type SignupCopiesType = typeof signupCopies_en;

export const navbarData_en = {
  navbarItems: navbarItems_en,
  signupCopies: signupCopies_en,
};

export const navbarData_us = {
  navbarItems: navbarData_en.navbarItems.map((item) => {
    if (item.name === "Products" && item.type === "Menu") {
      return {
        ...item,
        menuItems: item.menuItems.filter(
          (menuItem) => menuItem.name !== "Telegram Communities"
        ),
      };
    }
    return item;
  }),
  signupCopies: signupCopies_en,
}



export type NavbarDataType = {
  navbarItems: typeof navbarItems_en;
  signupCopies: typeof signupCopies_en;
  graphyLogoOnClick?: {
    href: string;
    amplitudeEvent: any;
  };
  registrationButton?: {
    ctaText: string;
    ctaLink: string;
  };
  registrationButtonUS?: {
    ctaText: string;
    ctaLink: string;
  };
    promotionStripData?: {
      type: string;
      percentage: number;
      endAfterHour: number;
      href: string;
      amplitudeEvent: {
        eventName: string;
        eventProperties: {};
      };
    };
    promotionStripDataUS?: {
      type: string;
      text: string;
      endAfterHour: number;
      href: string;
      amplitudeEvent: {
        eventName: string;
        eventProperties: {};
      };
    };
};
